import AdminLoginPage from "@features/admin/pages/AdminLoginPage";
import { getAdminPassword, isAdminRouteEnabled, isAdminUnlocked } from "@features/admin/utils/adminSession";
import { Suspense, useState } from "react";
import { Outlet } from "react-router-dom";

function AdminPageFallback() {
  return (
    <div className="flex min-h-screen items-center justify-center bg-zinc-950 p-6 text-zinc-100">
      <p className="text-sm text-zinc-400" data-testid="admin-page-loading">
        Loading…
      </p>
    </div>
  );
}

export function AdminRoute() {
  const [unlocked, setUnlocked] = useState(() => isAdminUnlocked());

  if (!isAdminRouteEnabled()) {
    return (
      <div className="min-h-screen bg-zinc-950 p-6 text-zinc-100 flex items-center justify-center">
        <p className="max-w-md text-center text-sm text-zinc-400" data-testid="admin-disabled">
          Admin is not enabled. Set <code className="text-zinc-200">VITE_ADMIN_PASSWORD</code> in{" "}
          <code className="text-zinc-200">.env</code> (dev) or <code className="text-zinc-200">.env.production</code>{" "}
          before <code className="text-zinc-200">yarn build</code>, then redeploy.
        </p>
      </div>
    );
  }

  if (!unlocked || !getAdminPassword()) {
    return <AdminLoginPage onUnlocked={() => setUnlocked(true)} />;
  }

  return (
    <Suspense fallback={<AdminPageFallback />}>
      <Outlet />
    </Suspense>
  );
}
